<template>
	 <v-container style="padding: 0;">
		 <v-dialog title="约课设置" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>约课设置</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-1">
					<v-row dense>
						<v-col cols="12">
							<v-checkbox v-model="add.isAllowBook" label="开启约课" color="red" value="1" hide-details ></v-checkbox> 
						</v-col>
						<template v-if="add.isAllowBook=='1'">
							<v-col cols="12" class="mt-5">
								<v-text-field label="最大约课人数" type="number" v-model="add.maxBookQty" dense outlined></v-text-field>
							</v-col>
						</template>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"record-book-setting",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			record:{
				type:Object,
				default:{}
			},
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if (newVal){
					this.add.recordId = this.record.id;
					this.add.isAllowBook = this.record.isAllowBook;
					
					if(this.record.maxBookQty=="0"){
						this.add.maxBookQty = "";
					}else{
						this.add.maxBookQty = this.record.maxBookQty;
					}
					
				}
			},
			
		},
		data(){
			return {
				add: {
					recordId:"",
					isAllowBook:"0",
					maxBookQty:""
				},
				hideShow:this.show,
			}
		},
		mounted() {
			console.log("book-setting mounted");
		},
		methods:{
			
			submitAdd(){
				
				if (!this.add.recordId) {
					this.$noty.error('缺少参数');
					return
				}
				
				
				if (this.add.isAllowBook == '1'){
					if (!this.add.maxBookQty) {
						this.$noty.error('请输入最大约课人数');
						return
					}
				}else{
					this.add.isAllowBook = "0";
				}
				
						
				// api
				const that = this;
				let url = `/edu/record/book/setting`;
				let postData = {...this.add};
				
				console.log(postData);
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("设置成功");						
							this.$emit("success","");			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

<style>
</style>
